import { useState } from 'react';
import '../App.css';

function Home() {
    const [heroEmail, setHeroEmail] = useState('');
    const [heroStatus, setHeroStatus] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });
    const [status, setStatus] = useState(null);

    const handleHeroSubmit = async (e) => {
        e.preventDefault();
        setHeroStatus('loading');

        try {
            const res = await fetch('https://formsubmit.co/ajax/support@fiveguycarrentals.com', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify({
                    subject: 'New Demo Request - Fleetify',
                    message: `A new demo request was submitted from the homepage.\n\nEmail: ${heroEmail}`,
                    email: heroEmail
                })
            });

            if (res.ok) {
                setHeroStatus('success');
                setHeroEmail('');
                setTimeout(() => setHeroStatus(null), 5000); // Auto-hide after 5 seconds
            } else {
                setHeroStatus('error');
            }
        } catch (err) {
            console.error(err);
            setHeroStatus('error');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');

        try {
            const res = await fetch('https://formsubmit.co/ajax/support@fiveguycarrentals.com', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (res.ok) {
                setStatus('success');
                setFormData({ name: '', email: '', phone: '', message: '' });
            } else {
                setStatus('error');
            }
        } catch (err) {
            console.error(err);
            setStatus('error');
        }
    };

    return (
        <div className="home-root" style={{ background: "linear-gradient(120deg, #f8fafc 0%, #e0e7ff 100%)" }}>
            <section className="hero hero-gradient" aria-labelledby="hero-title">
                <div className="hero-gradient-blur hero-gradient-blur-one" aria-hidden="true"></div>
                <div className="hero-gradient-blur hero-gradient-blur-two" aria-hidden="true"></div>
                <div className="container hero-grid fade-in">
                    <div className="hero-copy">
                        <p className="hero-eyebrow">FLEETIFY SOFTWARE</p>
                        <h1 id="hero-title">Run your private rental</h1>
                        <p className="hero-subtitle">
                            Centralize bookings, fleet availability, payments, and customer messaging in one place with live data and built-in automations.
                        </p>
                        <form className="email-form" onSubmit={handleHeroSubmit} aria-label="Request Demo">
                            <input
                                type="email"
                                aria-label="Email for Demo"
                                placeholder="Enter your work email"
                                className="email-input"
                                value={heroEmail}
                                onChange={(e) => setHeroEmail(e.target.value)}
                                required
                            />
                            <button type="submit" className="btn btn-primary hero-btn-primary">
                                {heroStatus === 'loading' ? 'Sending...' : 'Get started - free demo'}
                            </button>
                        </form>
                        {heroStatus === 'success' && (
                            <p className="hero-message success">Thanks! Email received. We will contact you soon.</p>
                        )}
                        {heroStatus === 'error' && (
                            <p className="hero-message error">Something went wrong. Please try again.</p>
                        )}
                        <p className="trial-info">Free 7-day trial. No credit card required.</p>
                        <div className="hero-metrics" aria-label="Key performance stats">
                            <div>
                                <span className="hero-metric-value">32%</span>
                                <span className="hero-metric-label">Higher fleet utilization</span>
                            </div>
                            <div>
                                <span className="hero-metric-value">2 min</span>
                                <span className="hero-metric-label">Average lead response</span>
                            </div>
                            <div>
                                <span className="hero-metric-value">99.9%</span>
                                <span className="hero-metric-label">Uptime across channels</span>
                            </div>
                        </div>
                    </div>
                    <div className="hero-media">
                        <div className="browser-chrome">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <img src="/images/dashboard.gif" alt="Fleetify dashboard preview" className="hero-media-img" />
                        <div className="hero-media-note">
                            Live bookings, fleet utilization, and handoff to support in one view.
                        </div>
                    </div>
                </div>
            </section>

            <section className="rental-suite" id="rental-suite">
                <div className="container">
                    <div className="rental-suite-header">
                        <p className="rental-eyebrow">Everything you need</p>
                        <h2>Built for modern car rental operators</h2>
                        <p className="rental-subtitle">
                            Fleetify centralizes your vehicles, bookings, pricing, and website into one streamlined system, so you spend less time managing and more time scaling.
                        </p>
                    </div>

                    <div className="suite-grid">
                        <article className="suite-card">
                            <div className="suite-stat">25+ website blocks</div>
                            <h3>Drag-and-drop rental pages</h3>
                            <p>Create fleet pages, pricing tables, testimonials, and landing pages that instantly match your brand—no designer or developer needed.</p>
                        </article>

                        <article className="suite-card">
                            <div className="suite-stat">+34% more conversions</div>
                            <h3>Booking-optimized layouts</h3>
                            <p>Show availability, insurance options, and pricing upfront. Fleetify is designed so renters book faster and abandon carts less.</p>
                        </article>

                        <article className="suite-card">
                            <div className="suite-stat">60-second sync</div>
                            <h3>Real-time fleet updates</h3>
                            <p>Your website, calendar, and booking system stay synced every minute—no spreadsheets, no double entry, no outdated availability.</p>
                        </article>

                        <article className="suite-card">
                            <div className="suite-stat">Multi-location ready</div>
                            <h3>SEO & analytics built in</h3>
                            <p>Automatically generate location pages, metadata, and tracking events for GA4 and Meta, so your marketing performs better with less effort.</p>
                        </article>
                    </div>
                </div>
            </section>

            <section className="trusted-companies" id="trusted-companies">
                <h2>Top Companies Trusted by Fleetify</h2>
                <p>Leading businesses rely on Fleetify to streamline their car rental operations.</p>
                <div className="logo-slider" aria-label="Trusted companies carousel">
                    <div className="logo-track">
                        {(() => {
                            const base = [
                                "/images/fgcr.png",
                                "/images/cmg.png",
                                "/images/europcar.png",
                                "/images/golfy rentals.png",
                            ];
                            // Build a repeating unit long enough to exceed wide viewports
                            const unit = [...base, ...base, ...base, ...base]; // 4x
                            const sequence = [...unit, ...unit]; // two identical halves
                            return sequence.map((src, idx) => (
                                <div className="logo-item" key={`logo-${idx}`}>
                                    <img
                                        src={src}
                                        alt={`Trusted company ${(idx % base.length) + 1}`}
                                        className="logo"
                                        decoding="async"
                                    />
                                </div>
                            ));
                        })()}
                    </div>
                </div>
            </section>

            <section className="features" id="features">
                <div className="container">
                    <h2>Powerful Features Built for Car Rental Success</h2>
                    <div className="features-grid">
                        <div className="feature-card slide-up">
                            <span className="feature-icon" aria-label="Smart Pricing">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <circle cx="12" cy="12" r="9"></circle>
                                    <path d="M12 6v12"></path>
                                    <path d="M10.5 8.5h2.8a1.7 1.7 0 0 1 0 3.4h-2.6a1.6 1.6 0 1 0 0 3.2h2.9"></path>
                                </svg>
                            </span>
                            <h3>Smart Pricing</h3>
                            <p>Set rates by age, location, or season. Companies using our pricing engine saw a <strong>12% boost in revenue</strong>.</p>
                        </div>
                        <div className="feature-card slide-up" style={{ transitionDelay: "0.1s" }}>
                            <span className="feature-icon" aria-label="Auto Reminders">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <path d="M12 5a5 5 0 0 0-5 5v3a2 2 0 0 1-.7 1.5l-.8.6h13l-.8-.6A2 2 0 0 1 17 13v-3a5 5 0 0 0-5-5z"></path>
                                    <path d="M9.5 18a2.5 2.5 0 0 0 5 0"></path>
                                    <path d="M5 10h0"></path>
                                    <path d="M19 10h0"></path>
                                </svg>
                            </span>
                            <h3>Auto Reminders</h3>
                            <p>Cut no-shows by <strong>up to 40%</strong> with automated SMS and email reminders that keep renters on schedule.</p>
                        </div>
                        <div className="feature-card slide-up" style={{ transitionDelay: "0.2s" }}>
                            <span className="feature-icon" aria-label="Dashboard">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <path d="M5 15a7 7 0 0 1 14 0v1.5A1.5 1.5 0 0 1 17.5 18h-11A1.5 1.5 0 0 1 5 16.5z"></path>
                                    <circle cx="12" cy="12" r="1.2"></circle>
                                    <path d="M12 12l3-3.5"></path>
                                    <path d="M7.5 15h9"></path>
                                </svg>
                            </span>
                            <h3>All-in-One Dashboard</h3>
                            <p>Manage rentals, payments, and customer data in one place, saving an average of <strong>30 hours per month</strong>.</p>
                        </div>
                        <div className="feature-card slide-up" style={{ transitionDelay: "0.3s" }}>
                            <span className="feature-icon" aria-label="Online Booking">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <rect x="3" y="5" width="18" height="14" rx="2"></rect>
                                    <path d="M3 9h18"></path>
                                    <path d="M8 3v4"></path>
                                    <path d="M16 3v4"></path>
                                    <path d="M9 13h6"></path>
                                    <path d="M11 11v6"></path>
                                </svg>
                            </span>
                            <h3>Online Booking</h3>
                            <p>Accept bookings 24/7 with live availability, confirmations, and payments in one smooth checkout.</p>
                        </div>
                        <div className="feature-card slide-up" style={{ transitionDelay: "0.4s" }}>
                            <span className="feature-icon" aria-label="Inventory Management">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <path d="M5 7h14l-1 12H6z"></path>
                                    <path d="M7 7l1-4h8l1 4"></path>
                                    <path d="M9.5 11h5"></path>
                                    <path d="M9 14.5h6"></path>
                                </svg>
                            </span>
                            <h3>Inventory Management</h3>
                            <p>Track fleet status, maintenance, and utilization so every vehicle is in the right place at the right time.</p>
                        </div>
                        <div className="feature-card slide-up" style={{ transitionDelay: "0.5s" }}>
                            <span className="feature-icon" aria-label="Reporting">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <path d="M5 5h14v14H5z"></path>
                                    <path d="M8 13l3 3 5-7"></path>
                                    <path d="M10 10h.01"></path>
                                </svg>
                            </span>
                            <h3>Reporting</h3>
                            <p>Analyze revenue, utilization, and performance with shareable reports and clear visual insights.</p>
                        </div>
                        <div className="feature-card slide-up" style={{ transitionDelay: "0.6s" }}>
                            <span className="feature-icon" aria-label="Automated Workflows">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <rect x="4" y="4" width="6" height="6" rx="1.5"></rect>
                                    <rect x="14" y="4" width="6" height="6" rx="1.5"></rect>
                                    <rect x="4" y="14" width="6" height="6" rx="1.5"></rect>
                                    <path d="M10 7h4"></path>
                                    <path d="M7 10v4"></path>
                                    <path d="M17 10v4"></path>
                                    <path d="M10 17h4"></path>
                                </svg>
                            </span>
                            <h3>Automated Workflows</h3>
                            <p>Automate approvals, reminders, and handoff tasks so your team spends less time on repetitive work.</p>
                        </div>
                        <div className="feature-card slide-up" style={{ transitionDelay: "0.7s" }}>
                            <span className="feature-icon" aria-label="Audit Logs">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <path d="M6 4h9l3 3v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"></path>
                                    <path d="M14 3v4h4"></path>
                                    <path d="M8 11h8"></path>
                                    <path d="M8 15h5"></path>
                                    <path d="M8 8h2"></path>
                                </svg>
                            </span>
                            <h3>Audit Logs</h3>
                            <p>Track every change, booking update, and user action with exportable trails for compliance.</p>
                        </div>
                        <div className="feature-card slide-up" style={{ transitionDelay: "0.8s" }}>
                            <span className="feature-icon" aria-label="Role-Based Access">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <circle cx="9" cy="7" r="3"></circle>
                                    <path d="M3 20c0-3.3 2.7-6 6-6"></path>
                                    <path d="M16 11h4v6"></path>
                                    <path d="M16 17l-2 2"></path>
                                    <path d="M20 17l2 2"></path>
                                </svg>
                            </span>
                            <h3>Role-Based Access</h3>
                            <p>Control permissions by role - owners, managers, and agents - so the right people see the right data.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="tailored-software" id="tailored-software">
                <div className="container tailored-layout">
                    <div className="text-content">
                        <div className="tailored-pill">Smart workflows built for rentals</div>
                        <h2>Smart Fleet Management Software</h2>
                        <p className="tailored-lead">Keep bookings, fleet readiness, payments, and team workflows synced in one control center.</p>
                        <div className="tailored-highlights">
                            <div className="highlight-item">
                                <span className="highlight-icon" aria-hidden="true">⚡</span>
                                <div>
                                    <h4>Live availability</h4>
                                    <p>Instantly sync inventory across channels so every renter sees accurate options.</p>
                                </div>
                            </div>
                            <div className="highlight-item">
                                <span className="highlight-icon" aria-hidden="true">🔒</span>
                                <div>
                                    <h4>Secure operations</h4>
                                    <p>Role-based access, audit trails, and approvals keep control where you need it.</p>
                                </div>
                            </div>
                            <div className="highlight-item">
                                <span className="highlight-icon" aria-hidden="true">📱</span>
                                <div>
                                    <h4>Self-serve renters</h4>
                                    <p>Mobile-friendly booking and reminders reduce calls and no-shows automatically.</p>
                                </div>
                            </div>
                        </div>
                        <div className="tailored-stats">
                            <div className="stat-badge">
                                <span className="stat-value">24/7</span>
                                <span className="stat-label">online bookings</span>
                            </div>
                            <div className="stat-badge">
                                <span className="stat-value">30%</span>
                                <span className="stat-label">faster turnarounds</span>
                            </div>
                            <div className="stat-badge">
                                <span className="stat-value">99.9%</span>
                                <span className="stat-label">uptime SLA</span>
                            </div>
                        </div>
                        <a href="/product" className="btn btn-primary pulse">Learn More</a>
                    </div>
                    <div className="design-content">
                        <img src="/images/hero.png" alt="Cool Design" className="cool-design shadow-lg" />
                    </div>
                </div>
            </section>

            <section className="cta" id="contact">
                <div className="container">
                    <div className="cta-content">
                        <div className="cta-text">
                            <h2>Let's Connect</h2>
                            <p>Have questions or ready to elevate your car rental business? Contact us today, and we'll help you get started.</p>
                            <div className="cta-divider"></div>
                            <p className="cta-highlight">Note - <em>Join thousands of businesses using Fleetify to simplify their car rental operations. Your success starts here!</em></p>
                        </div>
                        <div className="cta-form">
                            <form className="contact-form" onSubmit={handleSubmit} aria-label="Contact Form">
                                <div className="form-group floating-label">
                                    <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} aria-required="true" />
                                    <label htmlFor="name">Name</label>
                                </div>
                                <div className="form-group floating-label">
                                    <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} aria-required="true" />
                                    <label htmlFor="email">Email</label>
                                </div>
                                <div className="form-group floating-label">
                                    <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} aria-required="true" />
                                    <label htmlFor="phone">Phone Number</label>
                                </div>
                                <div className="form-group floating-label">
                                    <textarea id="message" name="message" rows="4" required value={formData.message} onChange={handleChange} aria-required="true"></textarea>
                                    <label htmlFor="message">Message</label>
                                </div>
                                <button type="submit" className="btn btn-primary cta-btn pulse">Send Message</button>
                                {status === 'loading' && <p>Sending...</p>}
                                {status === 'success' && (
                                    <p className="success sent-animation">
                                        Success: Message sent successfully!
                                    </p>
                                )}
                                {status === 'error' && <p className="error">Something went wrong. Please try again.</p>}
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Home;






